import React, {useCallback, useMemo, useState} from 'react'
import {useField} from 'formik'
import {TComponentHref} from './_types'

const normalizeUrl = (raw: string): string => {
    const v = String(raw || '').trim()
    if (!v) return ''

    // если уже есть протокол — оставляем
    if (/^https?:\/\//i.test(v)) return v

    // если дали домен/путь — добавим https
    return `https://${v}`
}

const shorten = (url: string, max = 60) => {
    if (!url) return ''
    if (url.length <= max) return url
    return `${url.slice(0, max - 12)}…${url.slice(-10)}`
}

const ComponentHref: React.FC<TComponentHref> = ({article, is_disabled, placeholder = '—'}) => {
    const [{value}] = useField<any>(article)
    const [copied, setCopied] = useState(false)

    const href = useMemo(() => {
        if (!value) return ''

        // поддержка случаев, когда вдруг прилетает объект/массив
        if (typeof value === 'string') return normalizeUrl(value)

        if (Array.isArray(value) && value[0]) {
            const first = value[0]
            if (typeof first === 'string') return normalizeUrl(first)
            if (typeof first === 'object' && first?.value) return normalizeUrl(first.value)
        }

        if (typeof value === 'object' && value?.value) {
            return normalizeUrl(value.value)
        }

        return ''
    }, [value])

    const handleOpen = useCallback(() => {
        if (!href) return
        window.open(href, '_blank', 'noopener,noreferrer')
    }, [href])

    const handleCopy = useCallback(async () => {
        if (!href) return

        try {
            await navigator.clipboard.writeText(href)
            setCopied(true)
            setTimeout(() => setCopied(false), 1200)
        } catch (e) {
            // fallback
            const el = document.createElement('textarea')
            el.value = href
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            document.body.removeChild(el)

            setCopied(true)
            setTimeout(() => setCopied(false), 1200)
        }
    }, [href])

    if (!href) {
        return <div className='componentHref componentInfo'>{placeholder}</div>
    }

    return (
        <div className={`componentHref ${is_disabled ? 'disabled' : ''}`}>
            <a
                className='componentHref_link'
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                title={href}
                onClick={(e) => {
                    if (is_disabled) e.preventDefault()
                }}
            >
                {shorten(href)}
            </a>

            <div className='componentHref_actions'>
                <button
                    type='button'
                    className='btn btn-sm btn-light'
                    onClick={handleOpen}
                    disabled={Boolean(is_disabled)}
                >
                    Открыть
                </button>

                <button
                    type='button'
                    className='btn btn-sm btn-light'
                    onClick={handleCopy}
                    disabled={Boolean(is_disabled)}
                >
                    {copied ? 'Скопировано' : 'Копировать'}
                </button>
            </div>
        </div>
    )
}

export default ComponentHref
